// extracted by mini-css-extract-plugin
module.exports = {"button":"plainbutton_button__s3hE_","fadein":"plainbutton_fadein__NHpnf","loading":"plainbutton_loading__zQ9yh"};